import React, { useEffect, useState } from 'react'
import { useStore, Storage } from '../lib'
import { Link, NavLink, useHistory } from 'react-router-dom'

type Props = {
  isCompact?: boolean
  isActionsShown?: boolean
  isTimeShown?: boolean
  startTime?: number
  endTime?: number
  customScore?: number
  customErrors?: number
}
export const ScoreStats: React.FC<Props> = ({
  isCompact,
  isActionsShown,
  isTimeShown,
  startTime,
  endTime,
  customScore,
  customErrors,
}) => {
  const [username, setUsername] = useState<string>('')
  const [score, setScore] = useState<number>(0)
  const [errors, setErrors] = useState<number>(0)
  const [timeSec, setTimeSec] = useState<number>(0)
  const [successRate, setSuccessRate] = useState<number>(0)
  const [intervalHandler, setIntervalHandler] = useState<any>()
  const { state, setState } = useStore()
  const history = useHistory()

  useEffect(() => {
    if (isTimeShown && startTime && !endTime) {
      const interval = setInterval(() => {
        const diff = +new Date() - startTime
        setTimeSec(Math.floor(diff / 1000))
      }, 999)
      setIntervalHandler(interval)
      return () => {
        clearInterval(interval)
      }
    }
  }, [])

  useEffect(() => {
    if (isTimeShown && startTime && endTime && intervalHandler) {
      clearInterval(intervalHandler)
    }
  }, [endTime])

  useEffect(() => {
    setUsername(state.username)
    let [nextScore, nextErrors, nextSuccessRate] = [0, 0, 0]
    if (!customScore || !customErrors) {
      Object.keys(state.games).forEach((g: any) => {
        nextScore += state.games[g].score
        nextErrors += state.games[g].errors
      })
    }
    if (customScore !== undefined) {
      nextScore = customScore
    }
    if (customErrors !== undefined) {
      nextErrors = customErrors
    }
    setScore(nextScore)
    setErrors(nextErrors)
    nextSuccessRate = 100 - nextErrors / ((nextScore + nextErrors) / 100)
    setSuccessRate(isNaN(nextSuccessRate) ? 0 : nextSuccessRate)
  }, [state])

  const printCertificate = () => {
    history.push('/diplom')
  }

  const resetUserProgress = () => {
    if (confirm('Smazat záznam o předchozích hrách pro aktuálního uživatele?')) {
      setState({
        username,
        score: 0,
        errors: 0,
        timeMs: 0,
        isWinter: false,
        isFirstRun: true,
        games: {},
      })
    }
  }

  const logout = () => {
    Storage.setBackup(state.username, state)
    history.push('/login')
  }

  const scoreCssVal = { '--value': `${score}` } as React.CSSProperties
  const errorsCssVal = { '--value': `${errors}` } as React.CSSProperties
  const timeCssVal = { '--value': `${timeSec}` } as React.CSSProperties

  const maxPoints = 80
  const gameProgress = score / (maxPoints / 100)

  const sumGameTimeSecs = state.timeMs / 1000

  return null
  // return (
  //   <div className={`flex justify-start content-start text-left left-5 bottom-5 absolute z-10 opacity-90`}>
  //     {!isCompact && (
  //       <div className="shadow-xl stats">
  //         <div className="stat">
  //           {/*<div className="stat-figure text-info">*/}
  //           {/*  <div className="ml-5">*/}
  //           {/*    {gameProgress.toFixed(2)}%*/}
  //           {/*  </div>*/}
  //           {/*</div>*/}
  //           <div className="stat-title">Hráč</div>
  //           <div className="stat-value capitalize">{username}</div>
  //           <div className="stat-desc">
  //             <div>
  //               {/*{gameProgress.toFixed(2)}% hry splněno*/}
  //               {sumGameTimeSecs.toFixed(0)}s ve hře
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //     <div className={`shadow-xl stats${!isCompact ? ' ml-5' : ''}`}>
  //       <div className="stat">
  //         <div className="stat-title">Skóre</div>
  //         <div className="stat-value countdown">
  //           <span style={scoreCssVal} />
  //         </div>
  //         <div className="stat-desc">{successRate.toFixed(2)}% úspěšnost</div>
  //       </div>
  //     </div>
  //     {/*<div className="shadow-xl stats ml-5">*/}
  //     {/*  <div className="stat">*/}
  //     {/*    <div className="stat-title">Chyby</div>*/}
  //     {/*    <div className="stat-value countdown">*/}
  //     {/*      <span style={errorsCssVal} />*/}
  //     {/*    </div>*/}
  //     {/*    <div className="stat-desc">{(score > 0 ? (100 - successRate) : 0).toFixed(2)}% chybovost</div>*/}
  //     {/*  </div>*/}
  //     {/*</div>*/}
  //     {/*{isTimeShown && (*/}
  //     {/*  <div className="shadow-xl stats ml-5" style={{ width: '150px'}}>*/}
  //     {/*    <div className="stat">*/}
  //     {/*      <div className="stat-title">Čas</div>*/}
  //     {/*      <div className="stat-value countdown">*/}
  //     {/*        <span style={timeCssVal} />s*/}
  //     {/*      </div>*/}
  //     {/*      <div className="stat-desc">{Math.floor(state.timeMs / 1000) + timeSec}s celkem</div>*/}
  //     {/*    </div>*/}
  //     {/*  </div>*/}
  //     {/*)}*/}
  //     {isActionsShown && (
  //       <div className="shadow-xl stats ml-5">
  //         <div className="stat">
  //           <div className="stat-title">Akce</div>
  //           <div className="stat-value">
  //             <button className="btn btn-primary" disabled={gameProgress < 50} onClick={() => printCertificate()}>
  //               {gameProgress >= 100 ? 'Diplom' : `Diplom (${gameProgress.toFixed(0)}%)`}
  //             </button>
  //             <button className="btn text-black ml-2" onClick={() => resetUserProgress()}>
  //               Resetovat
  //             </button>
  //             <button className="btn text-black ml-2" onClick={() => logout()}>
  //               Odhlásit
  //             </button>
  //           </div>
  //           <div className="stat-desc pt-1">
  //             <progress value={gameProgress.toFixed(2)} max="100" className="progress progress-primary bg-info" />
  //           </div>
  //           {/*<div className="stat-figure text-info">*/}
  //           {/*  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-8 h-8 stroke-current">*/}
  //           {/*    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />*/}
  //           {/*  </svg>*/}
  //           {/*</div>*/}
  //         </div>
  //       </div>
  //     )}
  //     {!isActionsShown && (
  //       <div className="shadow-xl stats ml-5">
  //         <div className="stat">
  //           <div className="stat-title">&nbsp;</div>
  //           <div className="stat-value">
  //             {/*<button className="btn text-black ml-2" onClick={() => resetUserProgress()}>Resetovat</button>*/}
  //             <NavLink to={'/dashboard'} className="btn text-black">
  //               Zpět
  //             </NavLink>
  //           </div>
  //           {/*<div className="stat-desc pt-1">*/}
  //           {/*  <progress value={gameProgress.toFixed(2)} max="100" className="progress progress-primary bg-info" />*/}
  //           {/*</div>*/}
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // )
}
